var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shipment-payment-confirmation-view',{staticClass:"shipment-proposals-accept-dialog-payment-confirmation-view",attrs:{"shipment":_vm.shipment},on:{"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }